
import PublicPackageApi from '@/api/public';
import { cleanData } from '@/views/Map/utils';

export default {
  namespaced: true,
  state: {
    list: [],
    loading: false,
    params: {
      id: null,
      distance: 100,
      term: ''
    }
  },
  actions: {
    async getList(ctx) {
      ctx.commit('setLoading', true);
      ctx.commit('setError', null);
      try {
        const { data, meta } = await PublicPackageApi.getTrack(ctx.getters.params);
        ctx.commit('setList', data);
        ctx.commit('setMeta', meta);
      } catch (err) {
        console.log('ERR:', err);
        ctx.dispatch('errors/pushError', err, { root: true });
        ctx.commit('setError', err);
      } finally {
        ctx.commit('setLoading', false);
      }
    },


    changeParams(context, params) {
      context.commit('changeParams', params);
    }
  },

  mutations: {
    setLoading(state, value) {
      state.loading = value;
    },
    setError(state, err) {
      state.error = err;
    },

    setMeta(state, meta) {
      state.meta = meta;
    },

    setList(state, data) {
      // state.list = cleanData(data[0].samples);
      state.list = cleanData(data);
    },

    changeParams(state, data) {
      Object.assign(state.params, data);
    }
  },

  getters: {
    meta: state => state.meta,
    error: state => state.error,
    loading: state => state.loading,
    list: state => (state.list ? state.list : []),
    params: state => state.params
  }
}

